
<template>
    <div class="center examplex">
      <vs-row>
         <vs-col sm="12" lg="3" class="ml-auto">
               <vs-input v-model="search" placeholder="Buscar">
                  <template #icon>
                     <i class="fas fa-search"></i>
                  </template>
               </vs-input>
         </vs-col>
      </vs-row>
      <vs-table striped>
         <template #thead>
            <vs-tr>
               <vs-th :style="estatus == 'activo' ? 'width: 20%' : ''">
               ALUMNO
               </vs-th>
               <vs-th :style="estatus == 'activo' ? 'width: 20%' : ''">
               ACADÉMICO
               </vs-th>
               <vs-th v-if="estatus == 'activo'" style="width: 65%">
               BECA
               </vs-th>
            </vs-tr>
         </template>
         <template #tbody>
            <vs-tr
               :key="i"
               v-for="(tr, i) in $vs.getSearch(users, search)"
               :data="tr"
               class="becasBorder"
               style="vertical-align: top"
            >
               <vs-td>
                  <md-chip class="mini-chip col-blue"><strong>No. lista: {{tr.no_lista}}</strong></md-chip>
                  <p class="mb-0"><small><i>NOMBRE</i></small></p>
                  <p><strong>{{tr.nombre}}</strong></p>
                  <p class="mb-0"><small><i>MATRÍCULA</i></small></p>
                  <p><strong>{{tr.matricula}}</strong></p>
                  <vs-button
                     success
                     flat
                     :href="'/estado-de-cuenta/' + tr.persona_id + '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar"
                     blank
                  >
                     Gestión de finanzas
                  </vs-button>
               </vs-td>
               <vs-td>
                  <p class="mb-0"><small><i>CICLO ESCOLAR</i></small></p>
                  <p><strong>{{tr.cicloEscolar}}</strong></p>
                  <p class="mb-0"><small><i>PROGRAMA</i></small></p>
                  <p><strong>{{tr.programa}}</strong></p>
                  <p class="mb-0"><small><i>GRUPO</i></small></p>
                  <p><strong>{{tr.grupo}}</strong></p>
               </vs-td>
               <vs-td v-if="estatus == 'activo'">
                  <p class="mb-0"><small>BECA ACTIVA</small></p>
                  <md-chip class="mini-chip col-green"><strong>{{tr.beca_activa}}</strong></md-chip>
                  <hr>
                  <div v-if="estatus == 'activo'">
                     <vs-row v-for="(beca, i) in tr.ingresos" :key="i" class="becasBorder" style="padding: 0.75rem 0">
                        <vs-col w="4" v-if="beca.codigoDetalle" class="p-1">
                              <p class="mb-0"><strong>{{beca.codigoDetalle}}</strong></p>
                        </vs-col>
                        <vs-col w="4" v-if="beca.codigoDetalle" class="lineDivisor p-1 text-center">
                              <p class="mb-0"><small>MONTO: </small><strong>{{beca.monto | currency}}</strong></p>
                        </vs-col>
                        <vs-col w="4" v-if="beca.codigoDetalle" class="p-1 text-center">
                              <p class="mb-0"><small>FECHA: </small><strong>{{beca.fecha}}</strong></p>
                        </vs-col>
                        <!-- <vs-col w="4" class="text-center">
                              <md-chip :class="'mini-chip ' + becaStatus[estatus]['color']"><strong>{{becaStatus[estatus]['nombre']}}</strong></md-chip>
                        </vs-col> -->
                     </vs-row>
                  </div>
               </vs-td>
            </vs-tr>
         </template>
      </vs-table>
    </div>
</template>
<script>
    export default {
      props: [
         'users',
         'institucion',
         'cicloEscolar',
         'estatus'
      ],
      data:() => ({
         becasMovimientos: {
            'movimientosTotal': {
               'nombre': 'Total de movimientos',
               'color': 'md-primary'
            },
            'montoTotal': {
               'nombre': 'Monto total',
               'color': 'md-success'
            },
            'alumnosTotal': {
               'nombre': 'Alumnos totales',
               'color': 'md-info'
            }
         },
        becaStatus: {
            'activo': {
                'nombre': 'BECA APLICADA',
                'color': 'col-green'
            },
            'desaplicada': {
                'nombre': 'BECA DESAPLICADA',
                'color': 'col-yellow'
            }
        },
        search: ''
      })
    }
</script>

<style lang="scss" scoped >
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236)); 
    @include text-colors ('blue', #2874A6, rgb(214, 234, 248)); 
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
    @include text-colors ('yellow', #febf3d, rgb(255, 248, 236)); 
    @include text-colors ('blue', #2874A6, rgb(214, 234, 248)); 
}

.becasBorder:not(:last-child){
    border-bottom: 1px solid rgb(206, 206, 206);
}
.lineDivisor{
   border-left: 1px solid rgb(206, 206, 206);
   border-right: 1px solid rgb(206, 206, 206);
}
</style>

        